/**
 * Client-side password policy shown in the register form's checklist popover.
 * Mirrors the backend policy — pure and translation-free so it can be unit-tested;
 * the UI maps `labelKey` through `t()` (NS `login`).
 */
export interface PasswordRule {
  labelKey: string
  test: (pw: string) => boolean
}

export const PASSWORD_RULES: PasswordRule[] = [
  { labelKey: 'passwordRules.minLength', test: (pw) => pw.length >= 8 },
  { labelKey: 'passwordRules.upperCase', test: (pw) => /[A-Z]/.test(pw) },
  { labelKey: 'passwordRules.lowerCase', test: (pw) => /[a-z]/.test(pw) },
  { labelKey: 'passwordRules.number', test: (pw) => /[0-9]/.test(pw) },
  { labelKey: 'passwordRules.specialChar', test: (pw) => /[^A-Za-z0-9]/.test(pw) },
]

export const isPasswordValid = (pw: string): boolean => PASSWORD_RULES.every((rule) => rule.test(pw))
